export default __webpack_public_path__ + "f5d5fce2f36b5776eab8b314efc2dfd8.png";